import { Component, inject } from '@angular/core';
import { ToastOutletComponent } from './components/ui/toast-outlet/toast-outlet.component';
import {
  RouterOutlet,
  RouterLink,
  Router,
  NavigationEnd,
} from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterLink, MatIconModule, ToastOutletComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'blackadmin';
  themeService = inject(ThemeService);

  constructor(private router: Router) {
    // Pages outside the console (sign in, password) scroll the window. The
    // console scrolls its own column and resets it itself (PortalComponent).
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && typeof window !== 'undefined') {
        window.scrollTo({ top: 0, behavior: 'instant' });
      }
    });
  }

  ngOnInit() {
    this.themeService.getTheme();
  }
}
